import { DrawerPane, isDrawerPaneVisible } from 'owa-drawer';
import type { OwaHeaderPaneProps } from 'owa-header-types';
import { OWAIframe } from 'owa-iframe';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import type { FunctionComponent } from 'react';
import { microsoftRewardsTitle, rewardsPaneHeaderText } from './RewardsPane.locstring.json';
import { header, headerTitle, logo, titleText } from './RewardsPane.scss';

const REWARDS_IFRAME_URL =
    'https://www.bing.com/fd/auth/signin?action=interactive&provider=windows_live_id&return_url=https://www.bing.com/rewards/panelflyout?partnerId=OutlookOwa';
const rewardsIframeStyle = { border: 0, display: 'block', height: '100%', width: '100%' };

const rewardsPaneTitle = () => {
    return (
        <span className={headerTitle}>
            <svg
                className={logo}
                width="20"
                height="20"
                viewBox="0 0 21 21"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            <span className={titleText}>{loc(microsoftRewardsTitle)}</span>
        </span>
    );
};

const defaultExport: FunctionComponent<OwaHeaderPaneProps> = observer(function RewardsPane(
    props: OwaHeaderPaneProps
) {
    return (
        <DrawerPane
            paneId={props.paneId}
            headerText={rewardsPaneTitle()}
            headerClassName={header}
            noPadding={true}
            preserveContentOnDismiss={true}
            role={'complementary'}
            width={380}
        >
            <OWAIframe
                isVisible={isDrawerPaneVisible(props.paneId)}
                scenario="RewardsPane"
                src={REWARDS_IFRAME_URL}
                title={loc(rewardsPaneHeaderText)}
                style={rewardsIframeStyle}
            />
        </DrawerPane>
    );
},
'RewardsPane');

export default defaultExport;
